import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Returns the viewport to the top of the document on navigation, so a new page
 * always starts at its banner rather than mid-way down the previous scroll.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
